(function(){
'use strict';
if(window.__STPickupGuardV4)return;
window.__STPickupGuardV4=true;

var MIN=6;
var STORE_TZ='America/Chicago';
var SAME_DAY_CUTOFF_MINUTES=17*60;
var selectedCompany='';
var selectedDate='';
var selectedTime='';
var checkoutReady=false;
var locationRequiresDate=false;
var locationRequiresTime=false;
var lastPopupKey='';
var permitUntil=0;
var hideTimer=null;

function pad(n){return String(n).padStart(2,'0');}
function storeParts(){
  try{
    var parts=new Intl.DateTimeFormat('en-US',{
      timeZone:STORE_TZ,
      year:'numeric',month:'2-digit',day:'2-digit',
      hour:'2-digit',minute:'2-digit',hourCycle:'h23'
    }).formatToParts(new Date()),m={};
    parts.forEach(function(x){m[x.type]=x.value;});
    return {year:m.year,month:m.month,day:m.day,hour:Number(m.hour)||0,minute:Number(m.minute)||0};
  }catch(e){
    var d=new Date();
    return {year:String(d.getFullYear()),month:pad(d.getMonth()+1),day:pad(d.getDate()),hour:d.getHours(),minute:d.getMinutes()};
  }
}
function todayKey(){
  var p=storeParts();
  return p.year+'-'+p.month+'-'+p.day;
}
function afterCutoff(){
  var p=storeParts();
  return (p.hour*60+p.minute)>=SAME_DAY_CUTOFF_MINUTES;
}
function parseDate(v){
  var s=String(v||'').trim(),m;
  m=s.match(/\b(\d{4})[-\/]([01]?\d)[-\/]([0-3]?\d)\b/);
  if(m)return m[1]+'-'+pad(m[2])+'-'+pad(m[3]);
  m=s.match(/\b([01]?\d)\/([0-3]?\d)\/(\d{4})\b/);
  if(m)return m[3]+'-'+pad(m[1])+'-'+pad(m[2]);
  m=s.match(/\b(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{1,2}),\s*(\d{4})\b/i);
  if(m){
    var months={january:1,february:2,march:3,april:4,may:5,june:6,july:7,august:8,september:9,october:10,november:11,december:12};
    return m[3]+'-'+pad(months[m[1].toLowerCase()])+'-'+pad(m[2]);
  }
  return'';
}
function attr(cart,key){
  var attrs=(cart&&cart.attributes)||{},keys=Object.keys(attrs),needle=String(key).toLowerCase().replace(/[ _]/g,'-');
  for(var i=0;i<keys.length;i++){
    var k=String(keys[i]||'').toLowerCase().replace(/[ _]/g,'-');
    if(k===needle)return String(attrs[keys[i]]||'');
  }
  return'';
}
function cupcakeCount(cart){
  var total=0;
  var byobVariants={
    '43147449270343':4,
    '43147449532487':6,
    '43236321329223':12,
    '43236317298759':12
  };
  ((cart&&cart.items)||[]).forEach(function(it){
    var q=Math.max(0,Number(it.quantity)||0);
    if(!q)return;
    var title=String(it.product_title||it.title||'');
    var type=String(it.product_type||'').toLowerCase();
    var variant=String(it.variant_title||'');
    var handle=String(it.handle||'').toLowerCase();
    var props=it&&it.properties||{};
    var boxSize='';
    Object.keys(props).some(function(k){
      if(String(k||'').toLowerCase().replace(/[ _-]/g,'')==='boxsize'){
        boxSize=String(props[k]||'');
        return true;
      }
      return false;
    });
    var propMatch=boxSize.match(/\b(2|4|6|12)\b/);
    if(propMatch){total+=Number(propMatch[1])*q;return;}
    var variantCount=byobVariants[String(it.variant_id||it.id||'')];
    if(variantCount){total+=variantCount*q;return;}
    var box=title.match(/build your own box\s*\((2|4|6|12)\)/i);
    if(box){total+=Number(box[1])*q;return;}

    // Single cupcakes still count one per cart quantity.
    if(type==='individual cupcakes'||type==='individual cupcake'){
      total+=q;return;
    }

    // Only recognize cupcake products, never a dozen of cookies/berries.
    var themed=type.indexOf('themed cupcake')!==-1;
    var varietyBox=/^\s*(6|12)\s+(?:(?:gluten[\s-]*free|gf)\s+)?variety\s+(?:gift\s+)?box\b/i.exec(title);
    var namedCupcake=/cupcake/i.test(title)||/cupcake/i.test(type)||/(?:^|-)cupcakes?(?:-|$)/i.test(handle);
    var seasonalCupcake=handle==='spooky-halloween'||handle==='back-to-school';
    if(!themed&&!varietyBox&&!namedCupcake&&!seasonalCupcake)return;
    var descriptor=title+' '+variant;
    var perBox=1;
    if(varietyBox)perBox=Number(varietyBox[1]);
    else if(/\b(?:half(?:\s+a)?\s+dozen|6\s*(?:variety|cupcakes?|count|pack))\b/i.test(variant))perBox=6;
    else if(/\b(?:two\s+dozen|2\s+dozen|24\s*(?:cupcakes?|count|pack))\b/i.test(variant))perBox=24;
    else if(/\b(?:dozen|12\s*(?:variety|cupcakes?|count|pack))\b/i.test(descriptor)||themed)perBox=12;
    else if(/cake\s+and\s+cupcakes?\s+bento\s+box/i.test(title))perBox=6; // Complete gift set exempt from the loose-cupcake minimum.
    total+=perBox*q;
  });
  return total;
}
function isSameDay(){return /Order Today/i.test(selectedCompany);}
function isFuturePickup(){
  if(isSameDay())return false;
  return !!selectedDate&&selectedDate>todayKey();
}
function widgetReady(){
  try{
    if(window.Zapiet&&Zapiet.Widget&&typeof Zapiet.Widget.checkoutEnabled==='function'){
      return !!Zapiet.Widget.checkoutEnabled();
    }
  }catch(e){}
  return checkoutReady;
}
function pickupHost(){
  return document.getElementById('storePickupApp')||document.querySelector('[id*="storePickup"],[class*="store-pickup"]');
}
function textOf(el){return String(el&&el.textContent||'').replace(/\s+/g,' ').trim();}
function markHidden(el){
  if(!el||el===document.body||el===document.documentElement)return;
  el.setAttribute('data-st-order-today-hidden','1');
  el.style.setProperty('display','none','important');
}
function restoreOrderToday(){
  document.querySelectorAll('[data-st-order-today-hidden="1"]').forEach(function(el){
    el.style.removeProperty('display');
    el.removeAttribute('data-st-order-today-hidden');
  });
}
function hideOrderToday(){
  if(!afterCutoff()){restoreOrderToday();return;}
  var host=pickupHost();
  if(!host)return;

  var radios=host.querySelectorAll('input[type="radio"]');
  radios.forEach(function(input){
    var p=input;
    for(var i=0;i<5&&p&&p!==host;i++,p=p.parentElement){
      var t=textOf(p);
      if(/Order Today/i.test(t)&&!/Shop Sweet Treasures/i.test(t)){
        markHidden(p);
        return;
      }
    }
  });

  var nodes=host.querySelectorAll('label,button,[role="radio"],[role="option"],li,div,span');
  nodes.forEach(function(el){
    if(textOf(el)!=='Order Today')return;
    var c=el.closest('label,button,[role="radio"],[role="option"],li');
    if(c){markHidden(c);return;}
    c=el;
    for(var i=0;i<4&&c.parentElement&&c.parentElement!==host;i++){
      var parent=c.parentElement;
      var pt=textOf(parent);
      if(/Shop Sweet Treasures/i.test(pt))break;
      c=parent;
      var cls=String(c.className||'');
      if(/location|radio|option|method/i.test(cls))break;
    }
    markHidden(c);
  });
}
function scheduleHide(){
  clearTimeout(hideTimer);
  hideTimer=setTimeout(hideOrderToday,80);
}
function ensureModal(){
  var wrap=document.getElementById('stPickupGuardModal');
  if(wrap)return wrap;
  wrap=document.createElement('div');
  wrap.id='stPickupGuardModal';
  wrap.setAttribute('role','dialog');
  wrap.setAttribute('aria-modal','true');
  wrap.setAttribute('aria-labelledby','stPickupGuardTitle');
  wrap.style.cssText='position:fixed;inset:0;z-index:2147483647;display:none;align-items:center;justify-content:center;padding:24px;background:rgba(0,0,0,.48);';
  wrap.innerHTML='<div style="width:min(92vw,430px);background:#fff;border-radius:18px;padding:28px 24px;box-shadow:0 18px 60px rgba(0,0,0,.28);text-align:center;color:#361d13;font-family:inherit;"><div id="stPickupGuardTitle" style="font-size:24px;font-weight:700;margin-bottom:12px;">Please note</div><div id="stPickupGuardText" style="font-size:17px;line-height:1.5;margin-bottom:22px;"></div><button id="stPickupGuardOk" type="button" style="min-width:150px;border:0;border-radius:999px;padding:12px 24px;background:#361d13;color:#fff;font:inherit;font-weight:700;">OK</button></div>';
  document.body.appendChild(wrap);
  function close(){wrap.style.display='none';}
  wrap.querySelector('#stPickupGuardOk').addEventListener('click',close);
  wrap.addEventListener('click',function(e){if(e.target===wrap)close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  return wrap;
}
function showMessage(message,key,force){
  if(!force&&key&&key===lastPopupKey)return;
  if(key)lastPopupKey=key;
  var modal=ensureModal();
  modal.querySelector('#stPickupGuardText').textContent=message;
  modal.style.display='flex';
}
function hideMessage(){
  var modal=document.getElementById('stPickupGuardModal');
  if(modal)modal.style.display='none';
}
function minMessage(count){
  var left=Math.max(0,MIN-count);
  return 'Future orders have a minimum of 6 cupcakes or more. Your cart currently has '+count+'. Please add '+left+' more cupcake'+(left===1?'':'s')+' to continue.';
}
function cutoffMessage(){
  return 'Same-day ordering closes at 5:00 PM. Please choose Shop Sweet Treasures and a future pickup date.';
}
function readinessMessage(){
  if(isSameDay()){
    if(afterCutoff())return cutoffMessage();
    if(locationRequiresTime)return 'Order Today does not require you to choose a date. Please choose your pickup time to continue.';
    return 'Order Today does not require a pickup date. Please finish your pickup selection to continue.';
  }
  if(!selectedDate&&locationRequiresDate)return 'Please choose your future pickup date to continue.';
  if(locationRequiresTime&&!selectedTime)return 'Please choose your pickup time to continue.';
  return 'Please finish your pickup date and time selection before checkout.';
}
function fetchCart(){
  return fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json();});
}
function syncFromCart(cart){
  if(!selectedCompany)selectedCompany=attr(cart,'Pickup-Location-Company');
  if(!selectedDate)selectedDate=parseDate(attr(cart,'Pickup-Date'));
  if(!selectedTime)selectedTime=attr(cart,'Pickup-Time');
}
function evaluate(showMinimum){
  scheduleHide();
  return fetchCart().then(function(cart){
    syncFromCart(cart);
    var count=cupcakeCount(cart);
    if(afterCutoff()&&isSameDay()){
      if(showMinimum)showMessage(cutoffMessage(),'cutoff|'+todayKey(),false);
      return {count:count,invalid:true,cutoff:true};
    }
    var invalid=isFuturePickup()&&count>0&&count<MIN;
    if(invalid&&showMinimum){
      showMessage(minMessage(count),'min|'+selectedCompany+'|'+selectedDate+'|'+count,false);
    }else if(!invalid){
      if(isSameDay())lastPopupKey='';
      hideMessage();
    }
    return {count:count,invalid:invalid,cutoff:false};
  }).catch(function(){return {count:0,invalid:false,cutoff:false};});
}

/* ST 2026-10-09: Stop BYOB orders with conflicting box and Zapiet pickup dates. */
function byobPickupProblem(cart){
  var dates={},n=0,items=(cart&&cart.items)||[];
  for(var i=0;i<items.length;i++){
    var it=items[i]||{},p=it.properties||{},source=String(p['_Cupcake Source']||''),boxId=String(p['Box ID']||'');
    if(!/new\s*byob/i.test(source)&&!/^STBYOB-/i.test(boxId))continue;
    n++;
    var boxDate=parseDate(p['Pickup Date']||p['Pickup-Date']||'');
    if(!boxDate)return 'A Build Your Own Box in your cart has no valid pickup date. Please remove that box and rebuild it with your intended pickup date before checkout.';
    dates[boxDate]=true;
  }
  if(!n)return '';
  var boxDates=Object.keys(dates).sort();
  if(boxDates.length!==1)return 'Your Build Your Own Boxes have different pickup dates ('+boxDates.join(', ')+'). Every box in a single order must use the same pickup date. Please remove and rebuild the incorrect box, or place the dates as separate orders.';
  var boxDate=boxDates[0],cartDate=parseDate(attr(cart,'Pickup-Date')),widgetDate=parseDate(selectedDate);
  if(cartDate&&widgetDate&&cartDate!==widgetDate)return 'Your pickup calendar and order pickup date are not synchronized. Please reselect your pickup date and time in the pickup calendar. If the dates still disagree, refresh the cart before checkout.';
  var authoritative=widgetDate||cartDate;
  if(authoritative&&authoritative!==boxDate)return 'Pickup dates do not match. Your Build Your Own Box was created for '+boxDate+', but the pickup calendar is set to '+authoritative+'. To avoid a wrong-day order, please remove and rebuild the box using the correct date on Build Your Own Box, or change the pickup calendar to '+boxDate+'. The dates must match before checkout.';
  return '';
}
function autoSelectToday(){
  if(afterCutoff()||!isSameDay()||!locationRequiresDate)return;
  setTimeout(function(){
    var today=document.querySelector('.picker__day--today:not(.picker__day--disabled), [aria-current="date"]:not([aria-disabled="true"])');
    if(today&&typeof today.click==='function')today.click();
  },60);
}
function attachZapiet(){
  if(!window.ZapietEvent||typeof window.ZapietEvent.listen!=='function')return false;
  if(window.__STPickupGuardZapietAttachedV4)return true;
  window.__STPickupGuardZapietAttachedV4=true;

  window.ZapietEvent.listen('selected_method',function(method){
    if(String(method||'')!=='pickup')checkoutReady=false;
    scheduleHide();
  });
  window.ZapietEvent.listen('locationSelected',function(params){
    selectedCompany=params&&params.location&&params.location.company_name?String(params.location.company_name):'';
    selectedDate='';
    selectedTime='';
    checkoutReady=false;
    locationRequiresDate=!!(params&&params.location&&params.location.date_picker_enabled);
    locationRequiresTime=!!(params&&params.location&&params.location.time_picker_enabled);
    lastPopupKey='';
    hideMessage();
    scheduleHide();
    if(afterCutoff()&&isSameDay()){
      // Automatic cutoff popup disabled; checkout click continues to enforce the 5 PM cutoff.
      return;
    }
    if(isSameDay())autoSelectToday();
    setTimeout(function(){evaluate(false);},80);
  });
  window.ZapietEvent.listen('pickup.datepicker.rendered',function(){
    scheduleHide();
    if(!afterCutoff()&&isSameDay())autoSelectToday();
  });
  window.ZapietEvent.listen('checkoutEnabled',function(params){
    if(params&&params.method&&String(params.method)!=='pickup')return;
    if(params&&params.location&&params.location.company_name)selectedCompany=String(params.location.company_name);
    if(params&&params.location){
      locationRequiresDate=!!params.location.date_picker_enabled;
      locationRequiresTime=!!params.location.time_picker_enabled;
    }
    if(params&&params.date)selectedDate=parseDate(params.date);
    if(params&&params.time)selectedTime=String(params.time);
    checkoutReady=true;
    scheduleHide();
    setTimeout(function(){evaluate(false);},60);
  });
  return true;
}
var attempts=0;
var attachTimer=setInterval(function(){
  attempts++;
  if(attachZapiet()||attempts>80)clearInterval(attachTimer);
},250);

document.addEventListener('click',function(e){
  var btn=e.target&&e.target.closest?e.target.closest('#CheckOut,button[name="checkout"],input[name="checkout"],button[type="submit"][form="cart"]'):null;
  if(!btn)return;
  if(Date.now()<permitUntil)return;

  e.preventDefault();
  e.stopImmediatePropagation();

  fetchCart().then(function(cart){
    syncFromCart(cart);
    var count=cupcakeCount(cart);
    var dateProblem=byobPickupProblem(cart);
    if(dateProblem){
      showMessage(dateProblem,'byob-pickup-date-conflict',true);
      return;
    }

    if(afterCutoff()&&isSameDay()){
      showMessage(cutoffMessage(),'cutoff-click|'+todayKey(),true);
      return;
    }

    if(isFuturePickup()&&count>0&&count<MIN){
      showMessage(minMessage(count),'min-click|'+selectedCompany+'|'+selectedDate+'|'+count,true);
      return;
    }

    if(!widgetReady()){
      showMessage(readinessMessage(),'ready|'+selectedCompany+'|'+selectedDate+'|'+selectedTime,true);
      return;
    }

    permitUntil=Date.now()+3000;
    setTimeout(function(){btn.click();},0);
  }).catch(function(){
    showMessage('Please finish your pickup selection before checkout.','cart-error',true);
  });
},true);

document.addEventListener('change',function(){
  scheduleHide();
  setTimeout(function(){evaluate(false);},100);
},true);

var observer=new MutationObserver(scheduleHide);
function observePickupHost(){
  var host=pickupHost();
  if(host){observer.observe(host,{childList:true,subtree:true,attributes:true});scheduleHide();return true;}
  return false;
}
var hostAttempts=0;
var hostTimer=setInterval(function(){
  hostAttempts++;
  if(observePickupHost()||hostAttempts>60)clearInterval(hostTimer);
},250);

setInterval(function(){
  scheduleHide();
  if(afterCutoff()&&isSameDay())checkoutReady=false;
},30000);

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',function(){attachZapiet();observePickupHost();evaluate(false);},{once:true});
}else{
  attachZapiet();
  observePickupHost();
  evaluate(false);
}
})();